const blogListSlider = document.querySelectorAll('[data-slider="blog-list__slider"]');

const blogListSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 12,
  watchOverflow: true,
  watchSlidesProgress: true,
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 22,
    },
    1023: {
      slidesPerView: 3,
      spaceBetween: 22,
    },
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
};

blogListSlider.forEach((el) => {
  const parentElem = el.closest('.blog-list');
  const blogSliderSlide = parentElem.querySelectorAll('.swiper-slide');
  const arrowRight = parentElem.querySelector('.arrow-right');
  const arrowLeft = parentElem.querySelector('.arrow-left');

  if (blogSliderSlide.length === 1) {
    blogListSliderOptions.loop = false;
  }

  blogListSliderOptions.navigation.prevEl = arrowLeft;
  blogListSliderOptions.navigation.nextEl = arrowRight;

  // eslint-disable-next-line no-new
  new Swiper(el, blogListSliderOptions);
});
